import validateFieldForPlaceholder from 'lib/validateFieldPlaceholder';
import moment from 'moment';

/*
----------------------------------
parseStringNumberBool function
----------------------------------
This function parse the value for STRING, NUMBER, BOOLEAN type data
----------------------------------
*/
export const parseStringNumberBool = (value) => {
  const formattedField = validateFieldForPlaceholder(value);
  return formattedField;
};

/*
  ----------------------------------
  parseDate function
  ----------------------------------
  This function parse the value for DATE type data
  ----------------------------------
  */
export const parseDate = (value) => {
  const formattedDate =
    value && value.length > 0 && moment(value).isValid()
      ? moment(value).format('lll')
      : validateFieldForPlaceholder(null);
  return formattedDate;
};
